import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../moreCore/UI/Button/Button";
import "../../moreCore/UI/GenericDialog/GenericDialog";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import { VAM2types } from "../_loadingHelpers/VAMv2Types";
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { TabbingHelpers } from "../../more/Helpers";


class OpusFinder extends compose(FinderBaseV2) {
    //templateString = template;

    private _tableFormatter(cell: StaticTable.StaticTableCell<VAM2types.Opus>): boolean {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {
           
            default:
                return false;
        }
    }

    private _onClick_TableRow(row: StaticTable.StaticTableRow<VAM2types.Opus>, rowGroup: StaticTable.StaticTableRowGroup<VAM2types.Opus>): void {
        let entity = rowGroup.entity;
        // Details öffnent
        let entityview = new GenericEntityView();
        entityview.setup(entity.ID, entity.Classname, entity.opus_titel, "opus_titel", "dlg", null, "opusperformance", TabbingHelpers.getTabContainerName(this));
        //entityview.showAsDlg(entity.ID, entity.opus_titel);
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
   

        this.setupFinderWithCallfunctions(
            "Webtool_API_OpusPerformance__GetOpusFinderConfig",
            "Webtool_API_OpusPerformance__GetOpusFinderResult",
            lang.hitch(this, this._onClick_TableRow),
            lang.hitch(this, this._tableFormatter)
        );
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OpusFinder);